import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import authActions from '../../store/modules/auth/actions';
import Loader from '../../components/Loader';

const LogoutView = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authActions.logOut());
  }, [dispatch, location]);
  return <Loader />;
};

export default LogoutView;
